import React, { useState } from "react";
import "./App.css";

const BACKEND_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";
const PASSWORD = "changeme";

function SetMessageComponent({ messageType, title, description }) {
  const [step, setStep] = useState("auth");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  // Fetch current message
  const fetchCurrentMessage = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${BACKEND_URL}/get-${messageType}-message`);
      if (res.ok) {
        const data = await res.json();
        setMessage(data.text);
      } else {
        console.error(`Failed to fetch current ${messageType} message`);
      }
    } catch (err) {
      console.error(`Error fetching ${messageType} message:`, err);
    }
    setLoading(false);
  };

  // Handle password check
  const handleAuth = async (e) => {
    e.preventDefault();
    if (password === PASSWORD) {
      setStep("main");
      await fetchCurrentMessage();
    } else {
      alert("Incorrect password.");
    }
  };

  // Handle message submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setSuccess(false);
    try {
      const res = await fetch(`${BACKEND_URL}/set-${messageType}-message`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ text: message }),
      });
      if (res.ok) {
        setSuccess(true);
      } else {
        alert(`Failed to set ${messageType} message.`);
      }
    } catch (err) {
      alert("Error: " + err.message);
    }
    setSubmitting(false);
  };

  // Auth step
  if (step === "auth") {
    return (
      <div className="app-container" style={{ minHeight: "100vh", justifyContent: "center" }}>
        <div className="step-content" style={{ maxWidth: 400, margin: "auto", marginTop: "10vh" }}>
          <h2 className="scheduler-title" style={{ textAlign: "center" }}>Admin Login</h2>
          <form onSubmit={handleAuth}>
            <div className="input-row">
              <label htmlFor="password">Enter password:</label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                autoFocus
              />
            </div>
            <button className="next-button" type="submit" style={{ width: "100%" }}>
              Login
            </button>
          </form>
        </div>
      </div>
    );
  }

  // Main step
  return (
    <div className="app-container" style={{ minHeight: "100vh", justifyContent: "center" }}>
      <div className="step-content" style={{ maxWidth: 600, margin: "auto", marginTop: "10vh" }}>
        <h2 className="scheduler-title" style={{ textAlign: "center" }}>
          {title}
        </h2>
        <p style={{ textAlign: "center", marginBottom: "1.5rem" }}>
          {description}
        </p>
        {loading ? (
          <p style={{ textAlign: "center", marginBottom: "1.5rem" }}>Loading current message...</p>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="input-row">
              <label htmlFor="message">{title}:</label>
              <textarea
                id="message"
                value={message}
                onChange={e => setMessage(e.target.value)}
                rows={messageType === "text" ? 6 : 12}
                style={{
                  width: "100%",
                  fontSize: "1rem",
                  border: "1px solid #cccccc",
                  borderRadius: 4,
                  padding: "0.5rem",
                  resize: "vertical",
                  fontFamily: "inherit",
                  marginBottom: "1rem"
                }}
                required
              />
            </div>
            <button className="next-button" type="submit" style={{ width: "100%" }} disabled={submitting}>
              {submitting ? "Submitting..." : "Submit"}
            </button>
          </form>
        )}
        {success && (
          <p className="success-message" style={{ color: "green", textAlign: "center", marginTop: "1rem" }}>
            ✅ {title} updated!
          </p>
        )}
      </div>
    </div>
  );
}

export default SetMessageComponent;